<template>

<div :class="areyousender">
<div class="grid">

<div class="col-8 flex align-items-center justify-content-start">
 <p class="text-sm text-gray-800 font-bold " >{{sendername}}</p>	
</div>

<div class="col-4 flex align-items-center justify-content-end">
<p class="text-sm text-gray-800 font-bold">{{$filters.momentFormat( message.created_at," DD-MM-YYYY HH:mm")}} </p>
</div>

<div class="col-12" >
<p class="my-1" v-html="message.description"></p>
</div>
</div>
</div>
</template>

<script>
export default {

  name: 'TicketMessage',
  props:["message"],
  data () {
    return {

    }
  },
  computed:{
  	sendername()
  	{	
  		if(this.message.submitteduser.id ==this.$store.state.auth.user.id)
  		{
  			return this.$store.state.languages.lang_phrases.sizin_tarafinizdan_gonderildi
  		}
  		else
  		{
  			return this.message.submitteduser.name
  		}
  	},
  	areyousender()
  	{
  		if(this.$store.state.auth.user.id == this.message.submitted_by)
  		{
  			return "col-10 col-offset-2 sender_wrapper border-round-md px-4 mb-4"
  		}
  		else
  		{
  			return "col-10 message_wrapper border-round-md px-4 mb-4"
  		}
  	}
  }
}
</script>

<style lang="css" scoped>
.sender_wrapper{
	background-color: var(--primary-100);
}

.message_wrapper{
	background-color: var(--green-100);
}
</style>